<template>
    <div class="cart_order_box">
        <div class="container">
            <div class="cart_order">
                <!-- 添加 & 修改地址 -->
                <cart-order-address></cart-order-address>
                <!-- 选择部门 & 备注 -->
                <cart-order-department></cart-order-department>
                <!-- 表格 -->
                <cart-order-table></cart-order-table>
                <!-- 提交部分 -->
                <cart-order-submit></cart-order-submit>
                <!-- 地址模态框 -->
                <cart-order-dialog></cart-order-dialog>
				<!-- 模态框訂單詳情 -->
				<order-status-dialog v-if="dialogFalse"></order-status-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
    computed: mapState({
        cart_order: state => state.order.cart_order,
		id_order: state => state.order.id_order,
		dialogFalse: state => state.dialogFalse,
    }),
    components: {
        cartOrderAddress: () => import("@/components/cartOrderAddress"),
        cartOrderDepartment: () => import("@/components/cartOrderDepartment"),
        cartOrderTable: () => import("@/components/cartOrderTable"),
        cartOrderSubmit: () => import("@/components/cartOrderSubmit"),
        cartOrderDialog: () => import("@/components/cartOrderDialog"),
		orderStatusDialog: () => import("@/components/center/orderStatusDialogs"),
    },
    methods: {
        ...mapMutations([
            "setCartOrder",
            "setCartAddress",
            "setSelectAddress",
            "setCartDepartment"
        ]),
        ...mapActions([
            "getCartAddress",
            "getCartDepartment"
        ])
    },
	mounted() {
		// console.log(this.cart_order)
		// console.log(this.id_order)
		if(this.id_order.length==0){
			// 只传入 rec_id
			let rec_id = [];
			this.cart_order.find((val, index, arr) => {
			     rec_id.push(val.rec_id)		    
			})
			let array = []
			array.push(this.cart_order,rec_id)
			this.setCartOrder(array);	
		}
		
	},
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if(vm.cart_order.length > 0){
                vm.getCartAddress();
                vm.getCartDepartment();
            }else{
                vm.$router.push("/center/cart")
            }
        })
    },
    beforeRouteLeave (to, from, next) {
        // this.setCartOrder([]);
        // this.setCartAddress([]);
        // this.setSelectAddress({});
        // this.setCartDepartment([]);
        next();
    }
}
</script>

<style scoped>
.cart_order_box{
    padding: 30px 0;
    background: #f5f5f5;
}
.cart_order{
    padding: 20px;
    background: #fff;
}
</style>
